import { Pipe, PipeTransform } from '@angular/core';
import { IPenalty } from "libraries/service/resources/hotel/IResourceHotel";
import { ICancellationKeyword } from "../cancellation-conditions.interface";
import { Keyword } from "libraries/service/resources/booking/interfaces/get-bookings.enum";

@Pipe({
    name: 'isEqualKeyword'
})

export class IsEqualKeyword implements PipeTransform {
    public transform(penalty: IPenalty | IPenalty[], keywordList: ICancellationKeyword[], xCode: Keyword): boolean {
        if(penalty){
            const penalties: IPenalty[] = Array.isArray(penalty) ? penalty : [penalty];
            const priceId: string = penalties[0].priceId;

            const keyword: ICancellationKeyword = keywordList
                .find((keywordItem: ICancellationKeyword) => keywordItem.priceId === priceId);

            return keyword.xCode.includes(xCode);
        }

        return keywordList && keywordList[0].xCode.includes(xCode);

    }
}